export default {
  API_URL: "http://localhost:3000",
  APP_PATH: "",
  MAX_DAYS: 14,
  SHOP_ADDRESS: 'Route des Pistes',
  SHOP_CITY: 'Villard Reculas',
  SHOP_EMAIL: 'contact@ptitpingouin.com',
  SHOP_NAME: 'Ptit Pingouin',
  SHOP_PHONE: '04 76 80 45 58',
  SHOP_ZIPCODE: '38114',
  TVA_RATE: 0.2
}
